import useFilters from 'modules/core/components/DataTable/hooks/useFilters'

import { formattedAmount } from 'modules/banking/lib/paymentHelpers'
import { DataTableWidgetInsights } from 'modules/finance/components/Widgets/common/widgets'
import {
  buildPurchaseOrdersOrderedAmountInsightWidget,
  buildPurchaseOrdersPendingAmountInsightWidget,
} from 'modules/procurement/components/Widgets/PurchaseOrdersSingleAmountWidget'
import {
  buildPurchaseOrdersClosedCounterInsightWidget,
  buildPurchaseOrdersTotalCounterInsightWidget,
} from 'modules/procurement/components/Widgets/PurchaseOrdersSingleCounterWidget'

interface PurchaseOrdersInsightsProps {
  currency: string
  companyId: number
  locale: string
  search?: string
  vendorId?: number
}

export const PurchaseOrdersInsights = ({
  currency,
  companyId,
  locale,
  search,
  vendorId,
}: PurchaseOrdersInsightsProps) => {
  const { getFiltersVariables } = useFilters()
  const dataTableFilters = getFiltersVariables().filter ?? {}

  const amountFormatter = (value: unknown) =>
    formattedAmount({ amountCents: Number(value), currency, locale: locale })

  const queryArgs = { currency, companyId, search, vendorId }

  return (
    <DataTableWidgetInsights
      useBox
      widgets={[
        buildPurchaseOrdersTotalCounterInsightWidget({
          queryArgs: queryArgs,
          filters: dataTableFilters,
        }),
        buildPurchaseOrdersPendingAmountInsightWidget({
          queryArgs: queryArgs,
          filters: dataTableFilters,
          prepareDataArgs: { amountFormatter },
        }),
        buildPurchaseOrdersOrderedAmountInsightWidget({
          queryArgs: queryArgs,
          filters: dataTableFilters,
          prepareDataArgs: { amountFormatter },
        }),
        buildPurchaseOrdersClosedCounterInsightWidget({
          queryArgs: queryArgs,
          filters: dataTableFilters,
        }),
      ]}
      widgetWidth="full"
    />
  )
}
